<div class="transfer_container">
  <div class="container">
    <div class="infos">
      <p>Clicotte</p>
      <!-- <fa-icon [icon]="faInfoCircle" (click)="openDialogHistoryContainer()"></fa-icon> -->
      <fa-icon [icon]="faInfoCircle" [routerLink]="['/containers']" routerLinkActive="router-link-active"
        *ngIf="router.url !== '/containers'"></fa-icon>
    </div>
    <div class="progress">
      <div class="progress_container">
        <p [ngClass]="{progress_value_rigth: progressContainer > 5, progress_value_left: progressContainer <= 5}"
          *ngIf="showValue">{{progressContainer}}%</p>
      </div>
      <div class="progress_back"></div>
    </div>
  </div>
  <div class="btn_action">
    <fa-icon [icon]="faSyncAlt" matTooltip="Mettre à jour" matTooltipClass="tooltip"></fa-icon>
    <fa-icon [icon]="faPlusSquare" matTooltip="Nouveau container" matTooltipClass="tooltip"
      (click)="openDialogNewContainer()"></fa-icon>
  </div>
</div>
